var __TEMP__ = require('./_getNative.js');var getNative = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_root.js');var root = __REQUIRE_DEFAULT__(__TEMP__);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = WeakMap;
